import centuryGothic from '../assets/gothic.ttf';

export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        html {
            background: #160643;
        }
        body {
          background: url(${require(`../assets/background.jpg`)}) no-repeat;
          background-attachment: fixed;
          background-position-x: center;
          background-position-y: top;
          background-size: cover;
        }
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          height: 100%;
          min-height: 100%;
          overflow-x: hidden;
          user-select: none;
          width: 100%;
        }
        .games-filter-block {
          background: #000000c7;
        }
        .user-block {
          background: transparent;
          border: 1px solid #ffffffa3;
          border-radius: 4px;
          color: #white;
          padding-left: 4px;
          padding-right: 4px;
          width: 180px;
        }
        .user-block__value {
          font-weight: bold;
        }
        .live-lobby-controls {
            position: relative;
            z-index: 0;
        }
        .live-lobby-controls::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 200%;
            background:
                linear-gradient(135deg, #2b1c54 0px, #2b1c54 1%, transparent 150px),
                linear-gradient(180deg, #2b1c54 0px, #2b1c54 50px, transparent 100%);
            z-index: -1;
            pointer-events: none;
        }
        @font-face {
          font-family: 'CenturyGothic';
          src: url(${centuryGothic}) format('truetype');
          font-style: normal;
        }
      `,
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#160643"
        }
      }
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(255, 194, 9)',
    },
    secondary: {
      main: 'rgb(255, 194, 9)',
    },
    toolbar: {
      main: 'rgb(255, 194, 9)',
    }
  },
}
